import { render, staticRenderFns } from "./fortuneWheel.vue?vue&type=template&id=5541277a&scoped=true"
import script from "./fortuneWheel.vue?vue&type=script&lang=js"
export * from "./fortuneWheel.vue?vue&type=script&lang=js"
import style0 from "./fortuneWheel.vue?vue&type=style&index=0&id=5541277a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5541277a",
  null
  
)

export default component.exports